import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { push } from 'react-router-redux';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DELIVERY_POSTAL_CODE_ENDPOINT,
  DELIVERY_POSTAL_CODE_PRICE_ENDPOINT,
} from '../../config/endpoints';
import { BASIC_POST_CONFIG, DEFAULT_GET_CONFIG } from '../../config/rest';
import { DELIVERY_POSTAL_CODE_PRICE_PATH } from '../../config/paths';
import {
  CLEAR_DELIVERY_POSTAL_CODE_PRICE,
  CLEAR_DELIVERY_POSTAL_CODE_PRICES,
  FLAG_DELIVERY_POSTAL_CODE_PRICE_ACTIVITY,
  FLAG_GETTING_DELIVERY_POSTAL_CODE_PRICES,
  GET_DELIVERY_POSTAL_CODE_PRICE,
  GET_DELIVERY_POSTAL_CODE_PRICES,
} from '../types/cargo/DeliveryPostalCodePrice';
import { DELIVERY_POSTAL_CODE_TEMPLATE_FILENAME } from '../../config/constants';

const flagGettingDeliveryPostalCodePrices = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DELIVERY_POSTAL_CODE_PRICES,
    payload: flag,
  });

const getDeliveryPostalCodePrices =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDeliveryPostalCodePrices(true));
      const query = tableFilters;
      const url = `${DELIVERY_POSTAL_CODE_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response);
      const deliveryPrices = await response.json();
      dispatch({
        type: GET_DELIVERY_POSTAL_CODE_PRICES,
        payload: deliveryPrices,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingDeliveryPostalCodePrices(false));
    }
  };

const clearDeliveryPostalCodePrices = () => (dispatch) =>
  dispatch({
    type: CLEAR_DELIVERY_POSTAL_CODE_PRICES,
  });

const flagDeliveryPostalCodePriceActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_DELIVERY_POSTAL_CODE_PRICE_ACTIVITY,
    payload: flag,
  });

const getDeliveryPostalCodePrice =
  async ({ deliveryPostalCodePriceId }) =>
  async (dispatch) => {
    try {
      dispatch(flagDeliveryPostalCodePriceActivity(true));
      const url = `${DELIVERY_POSTAL_CODE_ENDPOINT}/${deliveryPostalCodePriceId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response);
      const deliveryPrice = await response.json();
      dispatch({
        type: GET_DELIVERY_POSTAL_CODE_PRICE,
        payload: deliveryPrice,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDeliveryPostalCodePriceActivity(false));
    }
  };

const clearDeliveryPostalCodePrice = () => (dispatch) =>
  dispatch({
    type: CLEAR_DELIVERY_POSTAL_CODE_PRICE,
  });

const postDeliveryPostalCodePrice =
  async ({ locationId, file }) =>
  async (dispatch) => {
    try {
      dispatch(flagDeliveryPostalCodePriceActivity(true));
      const url = `${DELIVERY_POSTAL_CODE_ENDPOINT}/import-data`;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('locationId', locationId || '');
      const response = await fetch(url, {
        ...BASIC_POST_CONFIG,
        body: formData,
      });
      await isErrorResponse(response);
      const deliveryPrice = await response.json();
      dispatch(push(`${DELIVERY_POSTAL_CODE_PRICE_PATH}/${deliveryPrice.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDeliveryPostalCodePriceActivity(false));
    }
  };

const getDeliveryPostalCodeExcelTemplate =
  async (locationId) => async (dispatch) => {
    try {
      dispatch(flagDeliveryPostalCodePriceActivity(true));
      const url = `${DELIVERY_POSTAL_CODE_ENDPOINT}/${locationId}/template`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response);
      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = DELIVERY_POSTAL_CODE_TEMPLATE_FILENAME;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDeliveryPostalCodePriceActivity(false));
    }
  };

const getDeliveryPostalCodePriceByDeliveryPostalCode =
  (deliveryPostalCode) => async (dispatch) => {
    try {
      dispatch(flagDeliveryPostalCodePriceActivity(true));
      const url = `${DELIVERY_POSTAL_CODE_PRICE_ENDPOINT}/${deliveryPostalCode}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      if (!response.ok) {
        return null;
      }

      const deliveryPostalCodePrice = await response.json();
      return deliveryPostalCodePrice || null;
    } catch (error) {
      console.error(error);
      return null;
    } finally {
      dispatch(flagDeliveryPostalCodePriceActivity(false));
    }
  };

export {
  flagGettingDeliveryPostalCodePrices,
  getDeliveryPostalCodePrices,
  clearDeliveryPostalCodePrices,
  getDeliveryPostalCodePrice,
  clearDeliveryPostalCodePrice,
  postDeliveryPostalCodePrice,
  getDeliveryPostalCodeExcelTemplate,
  getDeliveryPostalCodePriceByDeliveryPostalCode,
};
